import { UrlParamKeys } from '../../app/UrlParamKeys';
import { Tableau } from '../../common/utilities/TableauLog';
import { Helpers } from '../../ts/helpers/Helpers';
import { IAddOAuthResponseListenerWindow } from '../../connectivity/services/AddOAuthCredentialAction';
import { Location } from '../../common/react/Location';
import * as queryString from 'query-string';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';

interface IOpenerPage extends IAddOAuthResponseListenerWindow {
  tab: {
    LogOnView: {
      fireLogOnComplete: () => void;
    };
  };
}

function safelyCallFunction(func: () => void) {
  try {
    func();
  } catch (e) {
    Tableau.Logger().error(e);
  }
}


/**
 * Service providing common functionality to clients running in a popup window. 
 */
export namespace WindowPopupService {

  /**
   * If we are running in a pop-up window and we are running with closePopupWhenDone = true,
   * then inform our caller that the job is done and close the window. Else, do nothing.
   * 
   * @returns true if we are closing this popup window and should stop further processing; otherwise, false.
   */
  export function maybeNotifyAndClose(): boolean {
    const urlParams = <{[key: string]: string}>WindowLocationService.getHashQueryObject();
    const closePopupWhenDone = Helpers.BooleanQueryParamRegex.test(urlParams[UrlParamKeys.ClosePopupWhenDone]);
    const openerPage = <IOpenerPage> (<any>window.opener);
    if (openerPage && closePopupWhenDone) {
      if (openerPage.tableauPopupComplete) {
        safelyCallFunction(() => openerPage.tableauPopupComplete());
      }
      if (openerPage.tab && openerPage.tab.LogOnView) {
        safelyCallFunction(() => openerPage.tab.LogOnView.fireLogOnComplete());
      }

      window.close();
      return true;
    }
    return false;
  }
}

export type WindowPopupService = typeof WindowPopupService;
